import React, { useEffect, useState } from "react";
// import OfferCard from "./offercard";
import { Inbox } from "lucide-react";

import { mapFormDataToApiPayload } from "./FormMapper";
import { useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import callApi from "../../../../utility/apiCaller";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedOffer as setOfferToStore } from "../../../../store/app/aaSlice";
import OfferCard from "./offerCard2";
import Header from "../Header/header";
import useAddLead from "../../hooks/addLeadtoCRM";
// utils/emiCalculator.js
export function calculateEMI(principal, annualRate, months) {
  const r = annualRate / 12 / 100; // monthly interest rate
  if (r === 0) return Math.round(principal / months); // no interest case

  return Math.round(
    (principal * r * Math.pow(1 + r, months)) / (Math.pow(1 + r, months) - 1)
  );
}
async function withRetry(fn, retries = 2, delay = 2000) {
  let attempt = 0;
  while (attempt <= retries) {
    try {
      return await fn();
    } catch (err) {
      if (attempt === retries) throw err;
      console.warn(`Retrying... attempt ${attempt + 1} failed`);
      await new Promise((r) => setTimeout(r, delay * (attempt + 1)));
      attempt++;
    }
  }
}

const DMI_ID = "68ad8ed5078abf6c677e4303";
const DMI = "DMI";

// Wrapper to use offer object
export function getOfferEMI(offer, amount = null, tenor = null) {
  const principal = amount || offer.max_amount; // default use max loan amount
  const months = tenor || offer.max_tenor; // default use max tenor
  const roi = offer.roi;

  return calculateEMI(principal, roi, months);
}

export default function LoanOfferPage({
  setCurrentStep,
  formdata,
  applicationId,
  responseId,
  // leadId,
  MappedData,
  aaUrl,
  internalLeadId,
  setSelectedOffer,
}) {
  const offersData = useSelector((state) => state.app.allOffers);
  const [params] = useSearchParams();
  const dmioffersData = useSelector((state) => state.app.offers);
  const navigate = useNavigate();
  const user = useSelector((state) => state.app.user);
  console.log("offers: ", offersData);
  const aaSlice = useSelector((state) => state?.aa);
  let leadId = aaSlice?.internalLeadId;
  const dispatch = useDispatch();
  const [expandedId, setExpandedId] = useState(null);
  const [failedList, setFailedList] = useState([]);
  const addLead = useAddLead();
  // Flatten all offers
  const allOffers = Array.isArray(offersData)
    ? offersData.flatMap((item) => item.offers || [])
    : offersData?.offers
    ? offersData.offers
    : [];

  useEffect(() => {
    setExpandedId(offersData?.offers?.[0]?._id);
  }, []);

  // Find highest max_amount offer
  const highestAmountOffer =
    allOffers.length > 0
      ? allOffers.reduce((prev, current) =>
          current.max_amount > prev.max_amount ? current : prev
        )
      : null;

  const handleExpand = (id) => {
    setExpandedId(expandedId === id ? null : id);
  };

  //console.log("highestAmountOffer:", highestAmountOffer);

  // State to control iframe visibility
  const [showIframe, setShowIframe] = useState(false);
  const handleClickNext = async () => {
    if (!highestAmountOffer) return;

    try {
      // 1. Prepare the payload
      const payload = {
        lead: {
          dmi_offer: {
            tenure: highestAmountOffer.max_tenor,
            interest: highestAmountOffer.roi,
            amount: highestAmountOffer.max_amount,
          },
        },
      };

      // 2. Call the API using leadId from props
      await callApi(
        `v1/lead/${leadId}/update-lead-new`,
        "post",
        payload,
        "core", // Assuming "loan" sets the base URL
        user?.token ||
          "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2OTAxYjljZjIxZTZlNTJmYTQwNDAwNDkiLCJvdHAiOiIxMTExIiwiY29udGFjdF9waG9uZSI6Ijk2OTMxMzU0NjYiLCJvdHBfZXhwaXJ5IjoiMjAyNS0xMC0yOVQwNzowMzowMy43MDZaIiwiaWF0IjoxNzYxNzIwNzg3fQ.xJ3Qd29aQPzV6vfc-bm5XDaOyIF1dXI4dD3lRZxEBDo"
      );

      setSelectedOffer(payload.lead.dmi_offer);
      dispatch(setOfferToStore(payload.lead.dmi_offer));
      const updateResponse = await withRetry(() =>
        callApi(
          `v1/lead/${leadId}/update-lead-new`,
          "post",
          {
            lead: {
              is_claim_offer_click_completed: true,
              steps_completed: 6,
            },
          },
          "core",
          user?.token ||
            "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2OTAxYjljZjIxZTZlNTJmYTQwNDAwNDkiLCJvdHAiOiIxMTExIiwiY29udGFjdF9waG9uZSI6Ijk2OTMxMzU0NjYiLCJvdHBfZXhwaXJ5IjoiMjAyNS0xMC0yOVQwNzowMzowMy43MDZaIiwiaWF0IjoxNzYxNzIwNzg3fQ.xJ3Qd29aQPzV6vfc-bm5XDaOyIF1dXI4dD3lRZxEBDo"
        )
      );
      //console.log(updateResponse);

      // Call useAddLead hook when offer is selected
      if (leadId) {
        try {
          await addLead({
            leadId: leadId,
            lead_type: "live",
            priority: 2,
            stage: "Offer",
          });
        } catch (error) {
          console.error("Error adding lead to CRM:", error);
        }
      }

      // 3. Move to next step (show iframe or next UI)
      setCurrentStep((prev) => prev + 1);
    } catch (error) {
      console.error("Error updating lead:", error);
    }
  };

  return offersData?.offers?.length === 0 ? (
    <div className="max-w-[400px] mx-auto py-2 bg-[#004739] min-h-screen flex flex-col  relative overflow-hidden px-4">
      {/* Logos at the top */}
      <div className="flex justify-between w-full items-center mb-8">
        <img
          src="/assets/img/newLogo.png"
          alt="digitmoney logo"
          className="h-[17px] w-[100px]"
        />
        {/* <img
          src="/assets/img/dmiicon2.png"
          alt="DMI Finance logo"
          className="h-[32px] w-[123px]"
        /> */}
      </div>

      {/* Main Content */}
      <div className="bg-[#004739] rounded-[20px] border-[2px] mt-[10dvh] border-[#12F28033] px-6 py-8 text-center w-full">
        {/* Lucide Icon Illustration */}
        <Inbox className="mx-auto mb-4 h-[80px] w-[80px] text-[#00B894]" />

        {/* Title */}
        <h2 className="text-[28px] text-[#00B894] font-bomstad-semibold mb-2">
          Oops!
        </h2>

        {/* Message */}
        <p className="text-[16px] text-[#CCF8E1] leading-[22px] font-atkinson mb-6">
          We currently have no pre-approved offers available for you. <br />
          Please check back later.
        </p>

        {/* Action prompt */}
        <p className="text-[#00B894] text-[16px] font-bomstad-regular">
          Stay connected for exciting offers!
        </p>
      </div>

      {/* Disclaimer */}
      <p className="text-center text-[#006C56] text-[12px] leading-[14px] mt-6 px-4">
        *These offers are subject to change at the discretion of the Bank /
        NBFC. Please ensure your details are updated to receive the latest
        offers.
      </p>
    </div>
  ) : (
    <div className="max-w-[400px] mx-auto py-4 bg-[#004739] min-h-screen flex flex-col items-center relative overflow-hidden">
      {/* Background */}
      {/* <img
        src="/assets/img/newLogo.png"
        alt="digitmoney logo"
        loading="lazy"
        className="w-[142px] h-[24px] z-20"
      /> */}
      <div className="flex justify-center  w-full max-w-[400px] items-center px-4  pb-2 z-[900]">
        <img
          src="/assets/img/newLogo.png"
          alt="digitmoney logo"
          className="h-auto] w-[140px]"
        />
      </div>
      <img
        src="/assets/img/offerbgimg.png"
        alt="Background Design"
        className="absolute inset-0 w-full object-cover z-0"
      />

      {/* Main Content */}
      <div className="relative z-20 w-full px-4 mt-[180px]">
        {/* Congratulations Section */}
        <div className="bg-[#004739] rounded-[30px] py-4 border-[2px] border-[#12F28033] px-2 text-center text-white">
          <h2 className="text-[30px] text-[#00B894] font-bomstad-semibold ">
            Congratulations!
          </h2>
          <p className="mt-1 text-[17px] text-[#CCF8E1] leading-[20px] font-atkinson">
            You’re Pre-Qualified for a <br /> Personal Loan!
          </p>
        </div>

        {/* Offer Cards */}
        {/* <div className="mt-4 space-y-4">
          {highestAmountOffer ? (
            <OfferCard
              logoSrc="/assets/img/dmiicon.png"
              amount={`₹${highestAmountOffer.max_amount.toLocaleString()}`}
              tenure={`${highestAmountOffer.max_tenor} Months`}
              emi={"₹" + getOfferEMI(highestAmountOffer).toLocaleString()}
              buttonText="Claim Offer Now"
              onButtonClick={handleClickNext}
            />
          ) : (
            <p className="text-white text-center">No offers available</p>
          )}
        </div> */}

        <div className="mt-4 space-y-4">
          {offersData?.offers?.map((offer) => (
            <OfferCard
              setCurrentStep={setCurrentStep}
              key={offer._id}
              leadId={leadId}
              offer={offer}
              isExpanded={expandedId === offer._id}
              onExpand={() => handleExpand(offer._id)}
            />
          ))}
        </div>
        {offersData?.failedList.length > 0 && (
          <div
            className="p-4 rounded-xl bg-white-900/80   shadow-lg mx-2 mt-3"
            style={{ backgroundColor: "white" }}
          >
            <div className="flex items-center gap-2 mb-2">
              <span className="text-xs font-semibold uppercase tracking-wide text-red-500">
                Note
              </span>
            </div>

            {/* Note Text */}
            <p className="text-sm text-black-300 mb-4 leading-relaxed">
              {offersData?.failedList?.length > 0 && (
                <p className="text-sm text-black-300 mb-2">
                  There are no matching offers for your request from:{" "}
                  {offersData?.failedList.join(", ")}
                </p>
              )}
            </p>
          </div>
        )}

        {/* Iframe (shows only after button click) */}

        {/* Offer validity */}
        <p className="text-center text-[#00B894] text-[18px] font-bomstad-regular mt-6">
          Offer is valid for limited time
        </p>

        {/* Disclaimer */}
        <p className="text-center text-[#006C56] text-[12px] leading-[14px] mt-2 ">
          *These pre-approved offers are subject to change at discretion of Bank
          / NBFC after receiving all you documents and details. Final offer will
          be based on risk policy of Bank / NBFC. We do not guarantee that final
          offer will be same as Pre-approved offer.
        </p>
      </div>
    </div>
  );
}
